import 'intersection-observer';
import { useState, useRef, useEffect } from 'react';

export default function useIntersectionObserver(callback, options) {
    const [intersectionObserver] = useState(new IntersectionObserver(callback, options));
    const intersectionRef = useRef();

    useEffect(() => {
        const { current } = intersectionRef;
        if (current) {
            intersectionObserver.observe(current!);

            return () => {
                intersectionObserver.unobserve(current!);
            };
        }
    }, []);

    return intersectionRef;
}
